module.exports = __webpack_public_path__ + "img/tanchuang.f6fa9fe7.png";